// extracted by mini-css-extract-plugin
export default {"container":"FormTask_container__jqu1P","form":"FormTask_form__9luh8","formBody":"FormTask_formBody__vIKzw"};